import React, { Component } from "react";
import { Button, Row } from 'reactstrap';
import Switch from "COMPONENTS/CommonComponents/Switch/Switch";
import toastr from 'COMPONENTS/ShowTostr/ShowTostr';

import "./CustomerCoBrowse.less";
import { getMessage } from "CONFIG/i18n";
import { postMesageToCoBrowseIframeUtility,isDesktopView, isMobileView, isTabletPortrait, isTabletLandscape, getDeviceOS } from "UTILS/Utility";
import { customerCoBrowseActionV2 } from "CONFIG/ActionFactory";
import ic_plus from "ASSETS/Images/ic_zoom_in.svg";
import ic_plus_dark from "ASSETS/Images/ic_zoom_in_dark.svg";
import ic_minus from "ASSETS/Images/ic_zoom_out.svg";
import ic_minus_dark from "ASSETS/Images/ic_zoom_out_dark.svg";
import EndCobrowseConfirmationModal from "COMPONENTS/CommonComponents/Modal/Modal";
import ScreenMaskingContainer from "COMPONENTS/ScreenMasking/ScreenMaskingContainer";
import ScrollBar from "COMPONENTS/CommonComponents/ScrollBar/ScrollBar";
import { CUSTOMER_CO_BROWSE_ACTIONS, CUSTOMER_CO_BROWSE_RESPONSE,
  COMPONENT_IN_FOCUS, CO_BROWSE_LAYOUT } from "../../Utils/Constants";
import { isIOS } from 'react-device-detect';
import maskIconOn from 'ASSETS/Images/dashboard_menu/ic_mask_stop.svg';

const ZOOM = {
  PLUS: 0.2,
  MINUS: -0.2,
  MAX: 4.0,
  MIN: 0.4
};

/**
 * ■レイアウトコード(layoutCode)の内訳
 *
 * ・PC / CO_BROWSE_LAYOUT.laptop / 1
 *  幅1600、高さ900
 *
 * ・タブレット / CO_BROWSE_LAYOUT.tablet / 2
 *  幅768、高さ1024
 *
 * ・スマホ縦 / CO_BROWSE_LAYOUT.mobileVertical / 3
 *  幅375、高さ667
 *
 * ・スマホ横 / CO_BROWSE_LAYOUT.mobileHorizontal / 4
 *  幅667、高さ375
 */

class CustomerCoBrowse extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showEndCobrowseConfirmationModal: false,
      isFollowerEdit: this.props.presenterSelectMutualEdit,
      orientation: null,
      zoom: 1.0,
      scale: null,
      appEmulationUrlForOwner: this.props.appEmulationUrlForOwner,
      appEmulationUrlForOwner: this.props.appEmulationUrlForOwner,
      isOverflow: false,
    };
    this.customerCBIframeElement = React.createRef();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.isScreenMasking !== this.props.isScreenMasking) {
      this.resizeScreenMasking();
    }
    if (prevProps.appEmulationUrlForOwner !== this.props.appEmulationUrlForOwner) {
      this.setState({appEmulationUrlForOwner: this.props.appEmulationUrlForOwner});
    }
    if (prevProps.appEmulationUrlForFollower !== this.props.appEmulationUrlForFollower) {
      this.setState({appEmulationUrlForFollower: this.props.appEmulationUrlForFollower});
    }
    if(prevProps.isHideBar !== this.props.isHideBar){
      this.setZoomIconPosition();
      const isToggle = !this.props.isHideBar ? true : false;
      this.setIframeDimensions(undefined, isToggle);
    }
  }

  componentDidMount = () => {
    if (isIOS) {
      // Prevent display collapse during rotation in iOS.
      this.setCoBrowseElementsLayout();
    } else {
      // Prevent initial display collapse on low-height screens.
      setTimeout(() => {
        this.setCoBrowseElementsLayout();
      }, 0);
    }

    window.addEventListener("resize", this.handleResizeEvent);
    window.addEventListener("message", this.coBrowseMessageListener, false);
    if (this.props.componentInFocus !== COMPONENT_IN_FOCUS.CANVAS) {
      this.props.setComponentInFocus(COMPONENT_IN_FOCUS.CANVAS);
    }
    isMobileView(this.props.orientation) && this.props.toggleHideBar(true);
    this.resizeScreenMasking();
    this.setZoomIconPosition();

    this.addPinchOperationControl();
    const zoomButtons = document.getElementById("coBrowseZoomButtons");
    if (zoomButtons) {
      zoomButtons.addEventListener('dblclick', this.doubleClickZoomControl);
    }
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.handleResizeEvent);
    document.removeEventListener('click', this.handleOutsideClickEndMeeting);
    window.removeEventListener("message", this.coBrowseMessageListener, false);
    if(this.props.showAudioVideoComponent){
      this.props.setComponentInFocus(COMPONENT_IN_FOCUS.AUDIO_VIDEO);
    }

    this.removePinchOperationControl();
    const zoomButtons = document.getElementById("coBrowseZoomButtons");
    if (zoomButtons) {
      zoomButtons.removeEventListener('dblclick', this.doubleClickZoomControl);
    }
  }

  doubleClickZoomControl(e) {
    e.preventDefault();
  }

  handleResizeEvent = () => {
    this.setState({ zoom: 1.0 }, () => {
      this.setIframeDimensions();
    });
    this.setZoomIconPosition();
    this.resizeScreenMasking();
  };

  addPinchOperationControl() {
    document.addEventListener("touchstart", this.preventTouchStart, { passive: false });
    document.addEventListener("touchmove", this.preventTouchStart, { passive: false });
    if(isMobileView(this.props.orientation) || isTabletLandscape(this.props.orientation)){
      document.body.classList.add("overscroll-none");
      document.documentElement.classList.add("overscroll-none");
    }
  }

  removePinchOperationControl() {
    document.removeEventListener("touchstart", this.preventTouchStart, { passive: false });
    document.removeEventListener("touchmove", this.preventTouchStart, { passive: false });
    if(document.body.classList.contains("overscroll-none")) { 
      document.body.classList.remove("overscroll-none");
    }
    if(document.documentElement.classList.contains("overscroll-none")) { 
      document.documentElement.classList.remove("overscroll-none");
    }
  }

  preventTouchStart(e) {
    if (e.touches.length > 1) {
      e.preventDefault();
    }
  }

  coBrowseMessageListener = (event) => {
    this.getIframeMsg(event);
  }

  setZoomIconPosition = () => {
    const mobileBottomAreaToggleBtn = document.getElementById("mobileBottomAreaToggleBtn");
    const mobileBottomArea = document.getElementById("mobileBottomArea");
    const zoomButtons = document.getElementById("coBrowseZoomButtons");
    const padding = 8;

    if (mobileBottomAreaToggleBtn !== null && mobileBottomArea !== null && zoomButtons !== null && isMobileView(this.props.orientation)) {
      let position = mobileBottomAreaToggleBtn.offsetHeight + 12; // 12 is "bottom" value of .mobileBottomAreaToggleBtn
      if (!this.props.isHideBar) {
        position = mobileBottomArea.offsetHeight;
      }
      zoomButtons.style.bottom = position + padding + "px";
    }
  }

  setCoBrowseElementsLayout =() => {
    this.setIframeDimensions();
    this.resizeScreenMasking();
  }

  getIframeMsg = (event) => {
    if (
      event.origin == this.props.coBrowseBaseUrl
      && event.data
      && event.data.viewAction == CUSTOMER_CO_BROWSE_ACTIONS.CO_BROWSER_END
      && !this.props.endCustomerCBSession
    ) {
      switch (event.data.result) {
        case CUSTOMER_CO_BROWSE_RESPONSE.END_FAIL:
        case CUSTOMER_CO_BROWSE_RESPONSE.END_SUCCESS:
          if (this.props.isPresenter()) {
            this.props.handleCustomerCoBrowseEndSessionClick();
          } else {
            this.props.handleCustomerCoBrowseLeaveSessionClick();
          }
          break;
        case CUSTOMER_CO_BROWSE_RESPONSE.END_CANCEL:
          break;
        default:
          console.log("End session default call:", event.data);
          break;
      }
    }
  }

  sleep = (milliseconds) => {
    return new Promise(resolve => setTimeout(resolve, milliseconds));
  }

  isResetPosition = (iframe, iframeDiv) => {
    const mobileBottomArea = document.getElementsByClassName("mobileBottomArea");
    const margin = iframeDiv.offsetHeight - iframe.getBoundingClientRect().height;
    const isReset = margin < mobileBottomArea[0].offsetHeight ? true : false;
    return isReset;
  }

  /**
   * 「デバイス選択ダイアログ」で選択されたデバイスに応じたレイアウトに調整する
   * @param {*} _zoom
   * @returns
   */
  setIframeDimensions = (_zoom, toggle) => {
    const iframe = document.getElementById("customerCBIframe");
    const iframeDiv = document.getElementById("customerCBIframeContainer");
    if (!iframe || !iframeDiv) {
      return;
    }
    const layoutCode = this.props.layoutCode;
    const resizeScale = isMobileView(this.props.orientation) && !this.props.isHideBar && (layoutCode == CO_BROWSE_LAYOUT.mobileVertical || layoutCode == CO_BROWSE_LAYOUT.tablet);

    // When the toggle menu is opened, adjust the height of the iframeDiv
    if (resizeScale) {
      const mobileBottomArea = document.getElementsByClassName("mobileBottomArea");
      if (mobileBottomArea[0]) {
        const padding = 10;
        const iframeDivHeight = _zoom ? iframeDiv.offsetHeight : iframeDiv.offsetHeight - mobileBottomArea[0].offsetHeight - padding;
        // Use cssText to override less
        iframeDiv.style.cssText = `height: ${iframeDivHeight}px !important`;
      }

      // If the toggle menu is open and the magnification is higher than the default, do not scale.
      if (this.state.zoom > 1.0 && toggle) {
        return;
      }
    } else {
      iframeDiv.style.height = "100%";
    }

    const zoom = _zoom ? _zoom : this.state.zoom;
    let iframeTop = iframe.offsetTop;
    let iframeHeightBeforeScale = screen.height;
    let iframeWidthBeforeScale = screen.width;

    let scaleFactor;
    let widthScaleFactor;
    let isOverflowWidth = false;
    // set iframeDiv width for zoom area bug on Safari browser
    if(zoom > 1){
      iframeDiv.style.width = "";
      setTimeout(()=>{
        iframeDiv.style.width = "100%";
      },30)
    }
    this.setState({isOverflow: zoom > 1});

    if (layoutCode == CO_BROWSE_LAYOUT.laptop) {
      iframeHeightBeforeScale = 900;
      iframeWidthBeforeScale = 1600;
      iframe.style.width = iframeWidthBeforeScale + 'px';
      iframe.style.height = iframeHeightBeforeScale + 'px';
      widthScaleFactor = iframeDiv.offsetWidth / iframeWidthBeforeScale;
      iframe.style.transform = `scale(${widthScaleFactor * zoom})`;
      iframe.style.left = "0px";
      // Sets the X = 0, y = 0 position of the iframe to the origin of the change
      iframe.style.transformOrigin = "0% 0%";
    } else if (layoutCode == CO_BROWSE_LAYOUT.tablet) {
      iframeHeightBeforeScale = 1024;
      iframeWidthBeforeScale = 768;
      iframe.style.width = iframeWidthBeforeScale + 'px';
      iframe.style.height = iframeHeightBeforeScale + 'px';
      iframeTop = 0;
      scaleFactor = iframeDiv.offsetHeight / iframeHeightBeforeScale;
      widthScaleFactor = iframeDiv.offsetWidth / iframeWidthBeforeScale;
      isOverflowWidth = iframeWidthBeforeScale * scaleFactor * zoom > iframeDiv.clientWidth;

      if(!_zoom){
        // initial display
        if(isOverflowWidth){
          iframe.style.transform = `scale(${widthScaleFactor * zoom})`;
          this.setState({ scale: widthScaleFactor });
        }else {
          iframe.style.transform = `scale(${scaleFactor * zoom})`;
          this.setState({ scale: scaleFactor });
        }
      }else {
        // after zoom in or zoom out
        iframe.style.transform = `scale(${this.state.scale * zoom})`;
      }
      
      // Position an iframe during tablet layout
      const iframeDivOffsetHight = iframeDiv.offsetHeight;
      const topValue = parseFloat((iframeDivOffsetHight - (scaleFactor * iframeHeightBeforeScale)) / 2);
      iframe.style.top = topValue + 'px';
      // Since the tablet layout is displayed in the center next to the parent layout, and there are left and right blanks, set the X half of the iframe, y = 0 position to the origin of the change.
      iframe.style.transformOrigin = (isMobileView(this.props.orientation) && zoom > 1.0 || isOverflowWidth) ? "0% 0%" : "50% 0%";
      iframe.style.left = (isMobileView(this.props.orientation) && zoom > 1.0 || isOverflowWidth) ? "0px" : null;
    } else if (layoutCode == CO_BROWSE_LAYOUT.mobileVertical) {
      iframeHeightBeforeScale = 667;
      iframeWidthBeforeScale = 375;
      iframe.style.width = iframeWidthBeforeScale + 'px';
      iframe.style.height = iframeHeightBeforeScale + 'px';
      iframeTop = 0;
      scaleFactor = iframeDiv.offsetHeight / iframeHeightBeforeScale;
      widthScaleFactor = iframeDiv.offsetWidth / iframeWidthBeforeScale;
      isOverflowWidth = iframeWidthBeforeScale * scaleFactor * zoom > iframeDiv.clientWidth;

      if(isOverflowWidth){
        iframe.style.transform = `scale(${widthScaleFactor * zoom})`;
      }else {
        iframe.style.transform = `scale(${scaleFactor * zoom})`;
      }

      const iframeDivOffsetHight = iframeDiv.offsetHeight;
      const topValue = parseFloat((iframeDivOffsetHight - (scaleFactor * iframeHeightBeforeScale)) / 2);
      iframe.style.top = isMobileView(this.props.orientation) ? "0px" : topValue + 'px';
      // Since the tablet layout is displayed in the center next to the parent layout, and there are left and right blanks, set the X half of the iframe, y = 0 position to the origin of the change.
      iframe.style.transformOrigin = (isMobileView(this.props.orientation) && zoom > 1.0 || isOverflowWidth) ? "0% 0%" : "50% 0%";
      iframe.style.left = (isMobileView(this.props.orientation) && zoom > 1.0 || isOverflowWidth) ? "0px" : null;
    } else if (layoutCode == CO_BROWSE_LAYOUT.mobileHorizontal) {
      iframeHeightBeforeScale = 375;
      iframeWidthBeforeScale = 667;
      iframe.style.width = iframeWidthBeforeScale + "px";
      iframe.style.height = iframeHeightBeforeScale + "px";
      widthScaleFactor = iframeDiv.offsetWidth / iframeWidthBeforeScale;
      iframe.style.transform = `scale(${widthScaleFactor * zoom})`;
      iframe.style.left = "0px";
      // Sets the X = 0, y = 0 position of the iframe to the origin of the change
      iframe.style.transformOrigin = "0% 0%";
    }
  }

  /**
   * redux store に格納されている AppEmulationUrl(オーナー、プレゼンター用) または AppEmulationUrlForFollower(フォロワー用) を返す
   * @returns AppEmulationUrl OR AppEmulationUrlForFollower
  */
  getCoBrowseSessionUrl = () => {
    if (this.props.isPresenter()) {
      // オーナー
      return this.state.appEmulationUrlForOwner;
    } else {
      // フォロワー
      return sessionStorage.getItem('reconnectionUrlForFollower')? sessionStorage.getItem('reconnectionUrlForFollower'): this.state.appEmulationUrlForFollower;
    }
  }

  handleOutsideClickEndMeeting = (event) => {
    if (event.target.className == 'modal fade show') {
      this.setState({
        showEndCobrowseConfirmationModal: false
      });

      document.removeEventListener('click', this.handleOutsideClickEndMeeting);
    }
  }

  /**
   * ×ボタンの押下でセッション破棄を実行
   * @param {*} modalState true/false
   * @returns
   */
  onOpenCloseEndCobrowseConfirmationModal = (modalState) => {
    if (modalState && !navigator.onLine) {
      toastr.error(getMessage("NETWORK_ERROR"));
      return;
    }

    this.setState({
      showEndCobrowseConfirmationModal: modalState
    });

    this.handleOutsideClickEndMeeting = this.handleOutsideClickEndMeeting.bind(this);
    document.addEventListener('click', this.handleOutsideClickEndMeeting);
  }

  handleEndLeaveCBSessionClick = () => {
    if (!this.props.isPresenter() && sessionStorage.getItem('reconnectionUrlForFollower')) {
      customerCoBrowseActionV2.showHideCustomerCoBrowse(false);
    }
    // Delete reconnection destination when cobrowsing ends
    sessionStorage.removeItem('reconnectionUrl');
    sessionStorage.removeItem('reconnectionUrlForFollower');
    postMesageToCoBrowseIframeUtility(this.props.token, this.props.coBrowseBaseUrl);
  }

  /**
   * ズームインボタン(+)、ズームアウトボタン(-)のハンドラメソッド
   * @param {*} zoom
   * @returns
   */
  iframeTransform = (zoom) => {
    if (((this.state.zoom + zoom) < ZOOM.MIN) || ((this.state.zoom + zoom) > ZOOM.MAX)) {
      return;
    }

    this.setIframeDimensions(this.state.zoom + zoom);
    this.setState({ zoom: this.state.zoom + zoom });
    this.props.isScreenMasking && this.resizeScreenMasking();
  }

  /**
   * iframe のロード時
   */
  iframeLoaded = () => {
    // iframe内をアクティブにする
    this.activateIFrameContent();

    // ------------------------------------------------------------------------

    // TODO: remove setTimeout once CB side issue fixed (issue: user ending session when iframe is loading)
    if (this.props.endCustomerCBSession && this.props.showCustomerCoBrowse && this.props.token && this.props.coBrowseBaseUrl) {
      setTimeout(() => {
        postMesageToCoBrowseIframeUtility(this.props.token, this.props.coBrowseBaseUrl);
        this.closeCustomerCbContainer();
      }, 1500); // 1.5sec delay required until iframe gets loaded completely... takes 1.5sec to load iframe
    }
  }

  /**
   * iframe内をアクティブにする
   * @returns
   */
  activateIFrameContent = () => {

    // iframeを格納する変数
    var iframe = null;

    // iframeを取得できるまでループ
    while (!iframe) {
      iframe = document.getElementById('customerCBIframe');
      this.sleep(100);
    }

    // div#togetherjs-modal-background で覆われているため、一度クリックしないとアクティブにならない。
    // そのため、上記タグを除去するよう、loookit-app-emulation にメッセージを送る。
    if (iframe.contentWindow && iframe.contentWindow.postMessage) {
      setTimeout(() => {
        iframe?.contentWindow?.postMessage('activate', '*');
      }, 1000);
    }
  }

  closeCustomerCbContainer = () => {
    setTimeout(() => {
      if (this.props.isPresenter()) {
        customerCoBrowseActionV2.endCustomerCoBrowse();
      } else {
        customerCoBrowseActionV2.leaveCustomerCoBrowse(this.props.uniqueId);
      }
    }, 500); // wait until message gets posted to CB properly then close CB container.... and after 2 sec will have to close cb container
  }

  /**
   * Control from the agent user
   * ON: only followers can edit themselves, owner cannot edit
   * OFF: only the owner can edit himself, cannot edit followers
   */
  followerEditSwitchListener = (toggleFlag) => {
    this.setState({
      isFollowerEdit: toggleFlag
    });

    // Tell followers that you pressed the follower edit toggle button
    this.props.handleCustomerCoBrowseFollowereditClick(toggleFlag, this.props.coBrowseBaseUrl);
  };

  resizeScreenMasking = () => {
    const customerCoBrowse = document.getElementById('customerCoBrowse');
    const customerCBIframeContainer = document.getElementById('customerCBIframeContainer');

    const customerCBIframe = document.getElementById("customerCBIframe");
    const screenMaskingDiv = document.querySelector("#customerCoBrowse .screenMaskingDiv");
    if (customerCBIframe && customerCBIframeContainer && screenMaskingDiv) {
      if (this.props.isScreenMasking && !(this.props.presenterId === this.props.uniqueId)) {
        screenMaskingDiv.style.height = customerCBIframeContainer.offsetHeight + 2 + 'px';
        screenMaskingDiv.style.width = customerCBIframeContainer.offsetWidth + 2 + 'px';
        if (isDesktopView(this.props.orientation)) {
          screenMaskingDiv.style.position = 'fixed';
        }
        customerCBIframe.style.visibility = 'hidden';
        customerCBIframeContainer.style.overflow = 'hidden';
      } else {
        screenMaskingDiv.style.height = '0px';
        screenMaskingDiv.style.width = '';
        screenMaskingDiv.style.position = 'absolute';
        customerCBIframe.style.visibility = '';
        customerCBIframeContainer.style.overflow = '';
      }
    }
  }

  render() {
    return (
      <div id="customerCoBrowse" className="paddingBottomCustomerCoBrowse">
        <div id="customerCoBrowseHeading" className={`row m-0 justify-content-end d-flex align-items-center py-2 flex-nowrap`}>
          {isMobileView(this.props.orientation) &&
            this.props.isScreenMasking &&
            (this.props.presenterId === this.props.uniqueId) &&
            <div id="coBrowseMaskIcon">
              <img
                src={maskIconOn}
              />
            </div>
          }
          {(this.props.isPresenter() && this.props.mutualEdit) &&
            <Row className="m-0 editText">
              <span>
                {getMessage("EDIT_FOLLOWER")}&nbsp;
              </span>
              <Switch
                switchOn={this.state.isFollowerEdit}
                toggleSwitch={(event) => { this.followerEditSwitchListener(event); }}
              />
            </Row>
          }
          <div className="displayFlex">
            {isDesktopView(this.props.orientation) &&
              this.props.isScreenMasking &&
              (this.props.presenterId === this.props.uniqueId) &&
              <div className="presenterMsgDiv positionCenter">
                <span className="presenterMsg">
                  {getMessage("YOUR_SCREEN_MASKED")}
                </span>
              </div>
            }
            <div id="coBrowseZoomButtons" className="zoomButtons">
              <img
                src={isMobileView(this.props.orientation) ? ic_plus_dark : ic_plus}
                className="mr-2 zoomBtn"
                onClick={() => this.iframeTransform(ZOOM.PLUS)}
                title={getMessage("ZOOMIN")}
              />
              <img
                src={isMobileView(this.props.orientation) ? ic_minus_dark : ic_minus}
                className="zoomBtn"
                onClick={() => this.iframeTransform(ZOOM.MINUS)}
                title={getMessage("ZOOMOUT")}
              />
            </div>
            <Button
              className="endSessionBtn whiteOnClick"
              aria-label="Cancel"
              onClick={() => this.onOpenCloseEndCobrowseConfirmationModal(true)}
              title={getMessage("END_CO_BROWSE")}
            >
              {getMessage("END_CO_BROWSE")}
            </Button>

            {
              this.state.showEndCobrowseConfirmationModal &&
              <EndCobrowseConfirmationModal
                show={true}
                isDoubleButton={true}
                handleYesClick={() => {
                  this.onOpenCloseEndCobrowseConfirmationModal(false);
                  this.handleEndLeaveCBSessionClick();
                }}
                handleNoClick={() => {
                  this.onOpenCloseEndCobrowseConfirmationModal(false);
                }}
                message={
                  this.props.isPresenter() ? getMessage("END_COBROWSE_CONFIRMATION_TEXT_PRESENTER")
                    : getMessage("END_COBROWSE_CONFIRMATION_TEXT")
                }
              />
            }

          </div>
        </div>
        <div id="customerCBIframeContainer" className="customerCBIframeContainer d-flex align-items-center justify-content-center" ref={this.customerCBIframeElement}>
          <ScreenMaskingContainer
            presenterId={this.props.presenterId}
            uniqueId={this.props.uniqueId}
          />
          <iframe
            name="customerCBIframe"
            id="customerCBIframe"
            title="customerCoBrowse"
            src={this.getCoBrowseSessionUrl()}
            height="100%"
            width="100%"
            onLoad={this.iframeLoaded}
          />
          {this.state.isOverflow && isMobileView(this.props.orientation) && getDeviceOS() === "Android" && 
            <ScrollBar target={this.customerCBIframeElement.current} />
          }
        </div>
      </div>
    );
  }
}

export default CustomerCoBrowse;
